module.exports = __webpack_public_path__ + "europa-20_ir.jpg?bf2559785dccc93b07c3567e7eb8a58e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-20_ir.jpg
// module id = 334
// module chunks = 0